import { isNil, toString } from 'lodash';
import { GREATER_THAN, IS_REQUIRED_ERROR } from 'common/constants/messages/validations';
import { SHEET_ALIASES_CONSTANTS } from 'pages/ValuationsAllocation/common/constants/futureExit/';
import { CellValidationParams } from 'pages/ValuationsAllocation/types';
import { getNumberValue, getObjectValue } from 'utilities';

const { FE_MODIFIED_PRESENT_EQUITY_VALUE_SPREADSHEET_DISCOUNT_RATE } = SHEET_ALIASES_CONSTANTS;
const DISCOUNT_RATE_FEEDBACK = GREATER_THAN(0);

const customValidations = (params: CellValidationParams) => {
  const { cell, addFeedbackFromCell, removeFeedbackFromCell } = params;
  const { alias, isRequired } = getObjectValue(cell);

  // Share values for a Future Exit can only be calculated with a positive discount rate, so a
  // missing or non-positive rate blocks the save instead of failing every later reallocation.
  if (alias === FE_MODIFIED_PRESENT_EQUITY_VALUE_SPREADSHEET_DISCOUNT_RATE && isRequired && cell) {
    if (isNil(cell.value) || toString(cell.value).trim() === '') {
      removeFeedbackFromCell?.(cell, DISCOUNT_RATE_FEEDBACK, undefined, true);
      addFeedbackFromCell?.(cell, IS_REQUIRED_ERROR);
      return;
    }
    removeFeedbackFromCell?.(cell, IS_REQUIRED_ERROR, undefined, true);

    if (getNumberValue(cell.value as number | string) <= 0) {
      addFeedbackFromCell?.(cell, DISCOUNT_RATE_FEEDBACK);
      return;
    }

    removeFeedbackFromCell?.(cell, DISCOUNT_RATE_FEEDBACK);
  }
};

export default customValidations;
